<script lang="ts">
  import { WebsiteName } from "../../../config"
</script>

<svelte:head>
  <title>Terms of Service - {WebsiteName}</title>
</svelte:head>

<div class="container mx-auto px-4 py-8">
  <div class="prose max-w-none">
    <h1>Terms of Service</h1>
    <p class="text-muted-foreground">
      Last updated: {new Date().toLocaleDateString()}
    </p>

    <h2>1. Introduction</h2>
    <p>
      Welcome to AceTheRound. By using our service, you agree to these terms.
      Please read them carefully.
    </p>

    <h2>2. Using our Services</h2>
    <p>
      You must follow any policies made available to you within the Services.
      You may use our Services only as permitted by law. We may suspend or stop
      providing our Services to you if you do not comply with our terms or
      policies or if we are investigating suspected misconduct.
    </p>

    <h2>3. Privacy & Copyright Protection</h2>
    <p>
      Our privacy policy explains how we treat your personal data and protect
      your privacy when you use our Services. By using our Services, you agree
      that we can use such data in accordance with our privacy policies.
    </p>

    <h2>4. Your Content in our Services</h2>
    <p>
      Our Services allow you to upload, submit, store, send or receive content.
      You retain ownership of any intellectual property rights that you hold in
      that content.
    </p>

    <h2>5. Service Modifications</h2>
    <p>
      We are constantly changing and improving our Services. We may add or
      remove functionalities or features, and we may suspend or stop a Service
      altogether.
    </p>

    <h2>6. Warranties and Disclaimers</h2>
    <p>
      We provide our Services using a commercially reasonable level of skill and
      care. But there are certain things that we don't promise about our
      Services.
    </p>

    <h2>7. Liability for our Services</h2>
    <p>
      When permitted by law, we will not be responsible for lost profits,
      revenues, or data, financial losses or indirect, special, consequential,
      exemplary, or punitive damages.
    </p>

    <h2>Contact Us</h2>
    <p>If you have any questions about these Terms, please contact us.</p>
  </div>
</div>
